module.exports = __webpack_public_path__ + "static/media/Website_Loop_2023.6128476b.mp4";